import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" {...props}><path fillRule="evenodd" d="M17.286 10.714h-6.072v6.072a.714.714 0 11-1.428 0v-6.072H3.714a.714.714 0 110-1.428h6.072V3.214a.714.714 0 111.428 0v6.072h6.072a.714.714 0 110 1.428" clipRule="evenodd" /></svg>;